<template>
  <div class="pl-5 mr-5 mt-3" v-show="is_loaded">
    <div>
      <portal to="inputs-grupo-filial">
        <div class="d-flex align-center">
          <SysGrupoAutocomplete
            v-model="filtros_gerais.grupos"
            label="Grupos de compras"
            outlined
            dense
            dark
            multiple
            height="10"
            class="w-200"
            hide-details
            ocultar_grupos_todos
            :auto_selecao_grupos="true"
            @change="aplicarFiltrosComDelay({...filtros_gerais, grupos: filtros_gerais.grupos})"
          />
        </div>

        <div class="d-flex align-center ml-3">
          <SysFilialGrupoAutocomplete
            v-model="filtros_gerais.filiais"
            :ids-grupo="filtros_gerais.grupos"
            label="Filiais"
            outlined
            dense
            dark
            multiple
            height="10"
            class="w-150"
            hide-details
            :qtde-visivel-selecionados="1"
            @change="aplicarFiltrosComDelay({...filtros_gerais, filiais: filtros_gerais.filiais})"
          />
        </div>
      </portal>
    </div>

    <div class="d-flex align-center">
      <div class="d-flex align-center">
        <v-icon color="#042333" :size="30" class="mr-1">mdi-finance</v-icon>
        <span class="font-25 font-weight-bold pr-5 text-systock-blue">Indicadores / Percepção de compras</span>
      </div>

      <Filtros @update:filtros="ev => aplicarFiltros(ev.filtros)" :filtro_linha="filtros_gerais.linhas" />
    </div>

    <div class="mt-6">
      <div class="d-flex align-center" style="height: calc(100vh - 345px)">
        <div class="h-full w-25-porcento">
          <GraficoDeTorta
            id="grafico-torta"
            :dados="dados_indicador"
            :cores="cores"
          />
        </div>

        <div class="h-full w-75-porcento">
          <GraficoDeBarra
            :dados="dados_indicador"
            id="grafico-empilhado"
            :cores="cores"
          />
        </div>
      </div>
    </div>

    <div>
      <Grid
        :cores="cores"
        :dados_indicador="dados_indicador"
        :filtros_gerais="filtros_gerais"
      />
    </div>
  </div>
</template>

<script>
import GraficoDeBarra from "./Graficos/GraficoDeBarra.vue";
import GraficoDeTorta from "./Graficos/GraficoDeTorta.vue";
import Filtros from "@/components/indicadores/PercepcaoCompras/Filtros.vue";
import SysFilialGrupoAutocomplete from "@/components/utils/crud/SysFilialGrupoAutocomplete.vue";
import SysGrupoAutocomplete from "@/components/utils/crud/SysGrupoAutocomplete.vue";
import Grid from "@/components/indicadores/PercepcaoCompras/Grid/Index.vue";
import {arrayColumn, logout} from "@/helpers";
import api from "@/api/api";

export default {
  components: {
    SysGrupoAutocomplete,
    SysFilialGrupoAutocomplete,
    Filtros,
    GraficoDeBarra,
    GraficoDeTorta,
    Grid,
  },
  data: () => ({
    filtros_gerais: {
      grupos: [parseInt(localStorage.getItem("config_grupo_compra_padrao"))],
      filiais: [],
      tipos_produtos: ['PRODUTOS_NAO_COMBINADOS', 'PRODUTOS_COMBINADOS'],
      compradores: [],
      segmentos: [],
      fornecedores: [],
      linhas: [],
      produtos_mix_filial: [2]
    },
    is_loaded: false,
    dados_indicador: {},
    timer_aplicar_filtro: null,
    cores: {
      sem_comportamento: "#000000",
      primeira_compra: "#0101DF",
      percepcao_em_ponto_de_pedido: "#04B431",
      percepcao_em_ruptura: "#FF0000",
      percepcao_com_elevada_prematuridade: "#042666",
      percepcao_com_elevada_exposicao_ruptura: "#FFBF00",
    },
  }),
  created() {
    this.getLinhaProdutos();
    this.is_loaded = true;
  },
  methods: {
    async getLinhaProdutos() {
      await api.get('/linhas')
        .then(response => this.filtros_gerais.linhas = arrayColumn(response.data.linhas.filter(f => f.com_movimento === 'S'), 'id'))
        .finally(() => this.buscarIndicadorPercepcaoCompra());
    },
    aplicarFiltrosComDelay(filtros) {
      clearTimeout(this.timer_aplicar_filtro);
      this.timer_aplicar_filtro = setTimeout(() => this.aplicarFiltros(filtros), 3000);
    },
    aplicarFiltros(filtros) {
      this.filtros_gerais = {
        ...this.filtros_gerais,
        ...filtros
      };

      this.buscarIndicadorPercepcaoCompra();
    },
    buscarIndicadorPercepcaoCompra() {
      this.is_loaded = false;
      api.post('indicadores/percepcao-compras', this.filtros_gerais)
        .then(response => this.dados_indicador = response.data.dados)
        .catch(logout)
        .finally(() => { this.is_loaded = true; this.ready = true })
    },
  },
};
</script>


<style scoped>
@media (max-width: 1000000000px) {
  #grafico-torta {
    width: 1550px;
    height: 1550px;
  }
}
@media (max-width: 7680px) {
  #grafico-torta {
    width: 1550px;
    height: 1550px;
  }
}
@media (max-width: 5120px) {
  #grafico-torta {
    width: 1180px;
    height: 1180px;
  }
}
@media (max-width: 3841px) {
  #grafico-torta {
    width: 850px;
    height: 850px;
  }
}
@media (max-width: 3441px) {
  #grafico-torta {
    width: 770px;
    height: 770px;
  }
}
@media (max-width: 3200px) {
  #grafico-torta {
    width: 700px;
    height: 700px;
  }
}
@media (max-width: 2561px) {
  #grafico-torta {
    width: 550px;
    height: 550px;
  }
}
@media (max-width: 2161px) {
  #grafico-torta {
    width: 450px;
    height: 450px;
  }
}
@media (max-width: 1921px) {
  #grafico-torta {
    width: 300px;
    height: 300px;
  }
}
@media (max-width: 1601px) {
  #grafico-torta {
    width: 300px;
    height: 300px;
  }
}
@media (max-width: 1367px) {
  #grafico-torta {
    width: 300px;
    height: 300px;
  }
}
@media (max-width: 1280px) {
  #grafico-torta {
    width: 260px;
    height: 260px;
  }
}
@media (max-width: 1024px) {
  #grafico-torta {
    width: 240px;
    height: 240px;
  }
}
@media (max-width: 960px) {
  #grafico-torta {
    width: 170px;
    height: 170px;
  }
}
</style>
